// import i18n from '@/i18n/index'

export default {
  tableDataItem: [{
    prop: 'id',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'group_name',
    label: '',
    Object: 'value',
    width: '150'
  }, {
    prop: 'rank',
    Object: 'value',
    label: '',
    width: '150'
  }, {
    prop: 'online',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'image',
    label: '',
    img: true,
    width: '120'
  }, {
    prop: 'begin_date',
    label: '',
    Object: 'value',
    width: '120'
  }, {
    prop: 'created_at',
    label: '',
    Object: 'value',
    width: '120'
  }]
}
